<div class="language-switch">
    <a [class]="{'active': languageSwitch.lang === 'D'}" (click)="switchLanguage('D')">DE</a> | 
    <a [class]="{'active': languageSwitch.lang === 'E'}" (click)="switchLanguage('E')">EN</a>
</div>